{
  "app": {
    "title": "لوحة إدارة العملاء المحتملين",
    "description": "إدارة العملاء المحتملين بكفاءة"
  },
  "navigation": {
    "dashboard": "لوحة القيادة",
    "leads": "العملاء المحتملين",
    "settings": "الإعدادات"
  },
  "common": {
    "save": "حفظ",
    "cancel": "إلغاء",
    "delete": "حذف",
    "edit": "تعديل",
    "add": "إضافة",
    "search": "بحث",
    "filter": "تصفية",
    "export": "تصدير",
    "import": "استيراد",
    "loading": "جاري التحميل...",
    "noData": "لا توجد بيانات",
    "error": "حدث خطأ",
    "success": "نجح"
  },
  "dashboard": {
    "title": "لوحة القيادة",
    "welcome": "مرحبا بك في {{displayName}}",
    "totalLeads": "إجمالي العملاء المحتملين",
    "newLeads": "عملاء جدد",
    "convertedLeads": "عملاء تم تحويلهم",
    "pendingLeads": "عملاء معلقين"
  },
  "leads": {
    "title": "العملاء المحتملين",
    "addLead": "إضافة عميل محتمل",
    "editLead": "تعديل العميل المحتمل",
    "deleteLead": "حذف العميل المحتمل",
    "name": "الاسم",
    "email": "البريد الإلكتروني",
    "phone": "الهاتف",
    "status": "الحالة",
    "source": "المصدر",
    "createdAt": "تاريخ الإنشاء",
    "updatedAt": "تاريخ التحديث"
  },
  "login": {
    "subtitle": "سنقوم بتسجيل دخولك أو إنشاء حساب إذا لم يكن لديك واحد بعد.",
    "authenticating": "جاري تسجيل الدخول...",
    "emailPlaceholder": "أدخل بريدك الإلكتروني",
    "continueWithEmail": "المتابعة بالبريد الإلكتروني",
    "otpSubtitle": "لقد أرسلنا كلمة مرور لمرة واحدة إلى بريدك الإلكتروني",
    "otpInstruction": "يرجى لصق (أو كتابة) الرمز المكوّن من 6 أرقام:",
    "verifying": "جاري التحقق من الرمز...",
    "agreementPrefix": "سنعالج بياناتك وفقًا لما هو محدد في",
    "dataProcessingAgreement": "اتفاقية معالجة البيانات"
  },
  "addContact": {
    "title": "إضافة جهة اتصال",
    "firstName": "الاسم الأول",
    "firstNamePlaceholder": "مثال: أحمد",
    "lastName": "اسم العائلة",
    "lastNamePlaceholder": "مثال: محمد",
    "jobTitle": "المسمّى الوظيفي",
    "jobTitlePlaceholder": "مثال: مصمم منتجات أول",
    "emailAddress": "البريد الإلكتروني",
    "emailPlaceholder": "مثال: ahmed@company.com",
    "adding": "جاري الإضافة...",
    "closeModal": "إغلاق"
  },
  "deleteLead": {
    "confirmMessage": "أنت على وشك حذف \"{{leadName}}\" نهائيًا. سيتم إزالة جميع جهات الاتصال والملفات الشخصية وبيانات الإثراء المرتبطة.",
    "deleting": "جاري الحذف...",
    "closeModal": "إغلاق"
  },
  "generateMore": {
    "pipelineGemini": "جلب من Gemini",
    "pipelineApollo": "جلب من Apollo (مُقيّد بـ Shopify)"
  },
  "deleteContact": {
    "title": "حذف جهة الاتصال",
    "confirmMessage": "هل أنت متأكد أنك تريد حذف \"{{contactName}}\"؟ سيتم إزالة جهة الاتصال من هذا العميل المحتمل."
  },
  "settings": {
    "title": "الإعدادات",
    "general": "عام",
    "profile": "الملف الشخصي",
    "language": "اللغة",
    "theme": "السمة",
    "notifications": "الإشعارات"
  }
}
